__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-auto-expense-rule/').replace(/[/]{3,}/g, "/");